import React from "react";
import hero from '../assets/img/Industries/academy_hero.jpg';
import sub_1 from '../assets/img/Industries/startup_psub_1.jpg';
import sub_2 from '../assets/img/Industries/startup_psub_2.jpg';
import sub_3 from '../assets/img/Industries/startup_psub_3.jpg';
import sub_4 from '../assets/img/Industries/startup_psub_4.jpg';
import { Link as RouterLink } from 'react-router-dom';

const StartUp = () => {

    return (
        <div className='portifoliobody'>
            <main id="main">
                <section id="pharma" className="about text-start" style={{paddingTop:'40px'}}>
                    <div className="ph-hero startup-hero">
                        <div className="ph-title carousel-container animate__animated animate__fadeInLeft" data-aos="fade-left" data-aos-delay="100">
                            <div className="ph-title-content" style={{color:'#fff'}}>
                                <h1>The Startup Accelerator by Lab Iconics</h1>
                                <p>Power your growing lab with cutting-edge informatics tools—efficient, scalable, and cost-effective.</p>
                            </div>
                            <div className="book_a_demo">
                                <RouterLink to='/demo'> 
                                    <button className="book_a_demo_btn">Get a Demo</button>
                                </RouterLink>
                            </div>
                        </div>
                        <div>
                            <img src="" alt="" />
                        </div>

                    </div>

                    <div className="section-container" style={{marginTop:'0'}}>
                        <div className="row">
                            <div className="section-pro">
                                <div className="sec-out">
                                    <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100" style={{justifyContent:'center', alignContent:'center'}}>
                                        <img src={sub_1} alt="pharma lab"/>
                                    </div>  
                                    <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                        <div className="sec-title"><h1>All-in-One Solution</h1></div>
                                        <ul>
                                            <li><b>Integrated Research Management  – </b> Track experiments, protocols, and results in one place.</li>
                                            <li><b>Real-time Collaboration – </b> Enable seamless teamwork with secure, cloud-based access. </li>
                                            <li><b>Automated Compliance Checks – </b>  Ensure regulatory adherence with built-in validation tools.</li>
                                            <li><b>Smart Workflow Automation – </b> Reduce manual work and focus on scientific breakthroughs.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="sec-out" style={{paddingTop:'4rem'}}>
                                    <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100" style={{justifyContent:'center', alignContent:'center'}}>
                                        <img src={sub_2} alt="pharma lab"/>
                                    </div>  
                                    <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                        <div className="sec-title"><h1>Affordable & Scalable</h1></div>
                                        <ul>
                                            <li><b>Flexible Pricing Plans – </b> Pay for what you need, with options to scale as you grow.</li>
                                            <li><b>Cloud-based Deployment – </b> Reduce IT costs with hassle-free setup and maintenance.</li>
                                            <li><b>Modular Features – </b> Add functionalities as your lab expands.</li>
                                            <li><b>Optimized Resource Utilization – </b> Minimize waste and maximize efficiency.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="section-pro">
                                <div className="sec-out">
                                    <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                        <div className="sec-title-2"><h1> Faster Research, Smarter Decisions</h1></div>
                                        <ul className='sec-ul'>
                                            <li style={{hyphens:'auto'}}><b>AI-driven Data Insights  –</b> Get actionable intelligence for better decision-making. </li>
                                            <li style={{hyphens:'auto'}}><b>Instant Data Retrieval  –  </b>Access past research in seconds with an intuitive search. </li>
                                            <li style={{hyphens:'auto'}}><b>Automated Experiment Tracking  – </b> Log every step for accuracy and reproducibility.</li>
                                            <li style={{hyphens:'auto'}}><b>Real-time Monitoring – </b>  Track project progress and optimize workflows instantly.</li>
                                        </ul>
                                    </div>
                                    <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100">
                                        <img src={sub_3} alt="" style={{width:'100%'}}/>
                                    </div>  
                                </div>
                            </div>
                            <div className="section-pro">
                                <div className="sec-out">
                                    <div className="sec-pro-desc" data-aos="fade-up" data-aos-delay="100">
                                        <div className="sec-title-2"><h1>Secure & Compliant</h1></div>
                                        <ul className='sec-ul'>
                                            <li style={{hyphens:'auto'}}><b>End-to-End Data Encryption –</b> Ensure your research stays confidential. </li>
                                            <li style={{hyphens:'auto'}}><b>Role-based Access Control –  </b>Assign permissions to safeguard sensitive information.  </li>
                                            <li style={{hyphens:'auto'}}><b>Audit Trails & Version Control – </b>Maintain transparency with trackable data changes.</li>
                                            <li style={{hyphens:'auto'}}><b>Regulatory Compliance Ready – </b>  Meet FDA, ISO, and other industry standards effortlessly.</li>
                                        </ul>
                                    </div>
                                    <div className="sec-pro-img" data-aos="fade-up" data-aos-delay="100">
                                        <img src={sub_4} alt="" style={{width:'100%'}}/>
                                    </div>  
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    )
}

export default StartUp;